
/**
 * Return a carousel to render on homepage by user region. Function always return a carousel value.
 * @param {string} regions
 * @param {object} homepage 
 */
export const selectCarouselByUserRegion = (regions, homepage) => {
  const defaultCarousel = homepage.carousel;

  if(!regions || regions === "")
    return defaultCarousel;

  const regionArr = regions.split(",");
  if(regionArr.length === 1) {
    // Only 1 region pass | regionArr[0]
    if(regionArr[0].toUpperCase() === "NA")
      return homepage.naCarousel;
    else if(regionArr[0].toUpperCase() === "EMEA")
      return homepage.emeaCarousel;
    else if(regionArr[0].toUpperCase() === "LAC")
      return homepage.lacCarousel;
    else if(regionArr[0].toUpperCase() === "APAC")
      return homepage.apacCarousel;
    else
      return homepage.naCarousel;
  }
  else if(regionArr.length > 1) {
    // Multiple regions pass, Okta user, rbiRegion = "Corporate"

    // Return naCarousel
    return homepage.naCarousel;
  }
}